/**
 * @generated SignedSource<<63175131a16ee011d4b1a6981c4ba3f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type bznavRefundGetDeligationInfoOfUserQuery$variables = {
  refundId: string;
};
export type bznavRefundGetDeligationInfoOfUserQuery$data = {
  readonly getDeligationInfoOfUser: {
    readonly address: string | null | undefined;
    readonly birthDate: string | null | undefined;
    readonly name: string | null | undefined;
    readonly result: boolean;
  };
};
export type bznavRefundGetDeligationInfoOfUserQuery = {
  response: bznavRefundGetDeligationInfoOfUserQuery$data;
  variables: bznavRefundGetDeligationInfoOfUserQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "refundId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "refundId",
        "variableName": "refundId"
      }
    ],
    "concreteType": "DeligationUserOutput",
    "kind": "LinkedField",
    "name": "getDeligationInfoOfUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "address",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "birthDate",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "bznavRefundGetDeligationInfoOfUserQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "bznavRefundGetDeligationInfoOfUserQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5522b7ba7f2b4766315e407d37ddf432",
    "id": null,
    "metadata": {},
    "name": "bznavRefundGetDeligationInfoOfUserQuery",
    "operationKind": "query",
    "text": "query bznavRefundGetDeligationInfoOfUserQuery(\n  $refundId: String!\n) {\n  getDeligationInfoOfUser(refundId: $refundId) {\n    result\n    name\n    address\n    birthDate\n  }\n}\n"
  }
};
})();

(node as any).hash = "e92d7399e8b86f7d85680415efee0425";

export default node;
